import React, { useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import hshape from "../assets/img/hshape.svg";
import axios from "axios";
import { partnerApi } from "../apis/homeApi";

const SimpleSlider = () => {
  const [partners, setPartners] = React.useState([]);
  const settings = {
    dots: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    initialSlide: 0,
    centerMode: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
          arrows: false,
        },
      },
    ],
  };
  useEffect(() => {
    try {
      axios.get(partnerApi).then((response) => {
        if (response.status === 200) {
          setPartners(response?.data?.data);
        }
      });
    } catch (error) {
      console.error("Error fetching partners:", error);
    }
  }, []);


  return (
    <section className="section-space pb-0">
      <div className="container-xl">
        <div className="row">
          <div className="col-lg-12 text-center">
            <div className="main-h">
              <h2 className="m-heading">Trusted Partners</h2>
              <img src={hshape} className="img-fluid" alt="logo" />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <Slider {...settings}>
              {partners?.map((partner, index) => (
                <div className="logo-box" key={index}>
                  <img src={partner?.logo} className="img-fluid" alt="Logo" />
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SimpleSlider;
